import auth from 'api/auth'
import Author from 'api/author'
import Home from 'api/home'
import Join from 'api/join'
import Notice from 'api/notice'
import Profile from 'api/profile'
import Tag from 'api/tag'
import Term from 'api/term'
import TextFigk from 'api/textFigk'
import Vote from 'api/vote'
const API = {
    Home,
    auth,
    Join,
    Author,
    TextFigk,
    Vote,
    Notice,
    Term,
    Tag,
    Profile,
}

export default API
